import { Box, Button, Checkbox, Grid, Link, MenuItem, Modal, Select, SelectChangeEvent, Stack, TextField, Typography, useMediaQuery } from "@mui/material"
import intlTelInput from "intl-tel-input";
import { useState } from "react";
import { axiosInstance } from "./tokenSetCookie";
import { Close } from "@mui/icons-material";
import { t } from "i18next";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import TermsandConditions from "../userAuth/Login/termsandconditions";
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
import instructions from "./../assets/instructions.png"
import planbg from "./../assets/images/planbackground/planbg.jpg"
import PlanDetails from "../components/Plan/PlanDetails";

interface BusinessInfo {
    businessName: string;
    emailId: string;
    businessPhone: string;
    address: string;
    city: string;
    stateProvince: string;
    country: string;
    countryFlag: string;
    countryCode: string;
    zipCode: string;
    noOfLocations: string;
    plan: string;
}


// const API_VITE_SANDBOX_PRICE_ID = import.meta.env.VITE_SANDBOX_PRICE_ID;
// const API_VITE_GYNAC_PRICE_ID = import.meta.env.VITE_GYNAC_PRICE_ID;
// const API_VITE_TRIAL_DAYS = import.meta.env.VITE_TRIAL_DAYS;
// const API_VITE_CHECKOUT = import.meta.env.VITE_CHECKOUT;
// const host = window.location.host;
// const LIGER_DOMAIN = import.meta.env.VITE_LIGER_HOST_NAME;
// const isLigerDomain = host.includes(LIGER_DOMAIN);


interface BusinessFormModalProps {
    onCloseModal: () => void;
}



export default function BusinessFormModal({ onCloseModal }: BusinessFormModalProps) {

    const expiryDate: string | null = localStorage.getItem("expiresOn");
    const isExpired = !expiryDate || new Date(expiryDate) < new Date();
    const isBusinessFilled: boolean = localStorage.getItem("businessStatus") === "true";
    const isMobile = useMediaQuery("(max-width:1200px)");

    // const [isPriceId, setPriceId] = useState("");
    const [modalType, setModalType] = useState<"terms" | "privacy">("terms");
    const [modalTitle, setModalTitle] = useState("");
    const [openterms, setOpenterms] = useState(false);
    const sessionId = localStorage.getItem("sessionId")
    console.log("sessionId", typeof sessionId)
    // const components = [3, 5, 7, 15, 30];
    // const [selected, setSelected] = useState<number | null>();
    const [openModal, setOpenModal] = useState(true);

    const [businessInfo, setBusinessInfo] = useState<BusinessInfo>({
        businessName: "",
        emailId: "",
        businessPhone: "",
        address: "",
        city: "",
        stateProvince: "",
        country: "",
        countryFlag: "us",
        countryCode: "+1",
        zipCode: "",
        noOfLocations: "1",
        plan: "",
    });

    const [businessFormErrors, setBusinessFormErrors] = useState<BusinessInfo>({
        businessName: "",
        emailId: "",
        businessPhone: "",
        address: "",
        city: "",
        stateProvince: "",
        country: "",
        countryFlag: "us",
        countryCode: "+1",
        zipCode: "",
        noOfLocations: "1",
        plan: "",
    });

    const [ligerModalOpen, setLigerModalOpen] = useState(false);

    // const priceMap: Record<string, string> = {
    //     ent: API_VITE_SANDBOX_PRICE_ID,
    //     obgyn: API_VITE_GYNAC_PRICE_ID,
    //     liger: API_VITE_SANDBOX_PRICE_ID,
    // };

    // useEffect(() => {
    //     // pick a random index on first render
    //     const randomIndex = Math.floor(Math.random() * components.length);
    //     setSelected(components[randomIndex]);
    // }, []);

    // useEffect(() => {
    //     const subdomain = window.location.hostname.split('.')[0]; // or your logic to get subdomain
    //     setPriceId(priceMap[subdomain] || API_VITE_SANDBOX_PRICE_ID);
    // }, [])

    const [isChecked, setIsChecked] = useState(false);
    const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setIsChecked(event.target.checked);
    };

    const handleBusinessInfoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // if (!analyticStarted) {
        //   setAnalyticStarted(true);
        //   handleBusinessFormStart();
        // }
        const { name, value } = e.target;
        setBusinessInfo((prev: BusinessInfo) => ({
            ...prev,
            [name]: value,
        }));
        // Clear error message when the user starts typing a valid value
        setBusinessFormErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "", // Reset error if corrected
        }));
    };



    const handleBusinessInfoSelect = (
        e: React.ChangeEvent<HTMLInputElement> | SelectChangeEvent<string>
    ) => {
        const { name, value } = e.target;
        setBusinessInfo((prev: BusinessInfo) => ({
            ...prev,
            [name]: value,
        }));
    };



    const style = {
        position: "absolute" as "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: { xs: "90%", sm: "60%", lg: isBusinessFilled ? "50%" : "100%", xl: isBusinessFilled ? "700px" : "100%" },
        maxWidth: "1200px",
        // height: "750px",
        bgcolor: "background.paper",
        borderRadius: "20px",
        boxShadow: 24,
    };

    const allowOnlyNumbers = (e: React.KeyboardEvent<HTMLInputElement>) => {
        const allowedKeys = [
            "Backspace",
            "Delete",
            "ArrowLeft",
            "ArrowRight",
            "Tab",
        ];

        if (!/^[0-9]$/.test(e.key) && !allowedKeys.includes(e.key)) {
            e.preventDefault();
        }
    };

    const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
        const pasteData = e.clipboardData.getData("text");
        if (!/^\d+$/.test(pasteData)) {
            e.preventDefault(); // Block if pasted content is not all digits
        }
    };


    const countryData = intlTelInput.getCountryData();
    const countryOptions = countryData
        .filter(
            (country) =>
                !(country.dialCode === "1" && country.iso2 !== "us") &&
                !(country.dialCode === "44" && country.iso2 !== "gb")
        )
        .map((country) => ({
            code: `+${country.dialCode}`,
            flag: country.iso2,
            name: country.name,
        }));

    const validateBusinessForm = () => {
        let valid = true;
        const newErrors = { ...businessFormErrors };

        // Validate Business name
        if (!businessInfo.businessName.trim()) {
            newErrors.businessName = "Business name is required";
            valid = false;
        }
        // Validate address
        if (!businessInfo.address.trim()) {
            newErrors.address = "Business address is required";
            valid = false;
        }
        // Validate phone
        if (!businessInfo.businessPhone.trim()) {
            newErrors.businessPhone = "Business phone is required";
            valid = false;
        }
        // Validate city
        if (!businessInfo.city.trim()) {
            newErrors.city = "Business city is required";
            valid = false;
        }
        // Validate state
        if (!businessInfo.stateProvince.trim()) {
            newErrors.stateProvince = "Business state is required";
            valid = false;
        }
        // Validate last name
        if (!businessInfo.country.trim()) {
            newErrors.country = "Country is required";
            valid = false;
        }
        // Validate last name
        if (!businessInfo.zipCode.trim()) {
            newErrors.zipCode = "Zipcode is required";
            valid = false;
        }
        // Validate email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!businessInfo.emailId.trim()) {
            newErrors.emailId = "Email is required";
            valid = false;
        } else if (!emailRegex.test(businessInfo.emailId)) {
            newErrors.emailId = "Invalid email format";
            valid = false;
        }
        // Validate phone number
        const phoneRegex = /^[0-9]{7,15}$/;
        if (!businessInfo.businessPhone.trim()) {
            newErrors.businessPhone = "Phone number is required";
            valid = false;
        } else if (!phoneRegex.test(businessInfo.businessPhone)) {
            newErrors.businessPhone = "Phone number must be 7-15 digits";
            valid = false;
        }
        setBusinessFormErrors(newErrors);
        return valid;
    };


    const emptyBusinessInfo = {
        businessName: "",
        emailId: "",
        businessPhone: "",
        address: "",
        city: "",
        stateProvince: "",
        country: "",
        countryFlag: "us",
        countryCode: "+1",
        zipCode: "",
        noOfLocations: "1",
        plan: "",
    };

    const handleSubmit = async () => {

        window.gtag("event", "business_form_submit_design_one", {
            page_path: window.location.pathname,
            form_type: "business_information",
            environment: process.env.NODE_ENV,
            // user_email: formData.email,
            businessName: businessInfo.businessName,
            businessEmailId: businessInfo.emailId,
            businessPhone:
                "+" + Number(businessInfo.countryCode) + businessInfo.businessPhone,
            businessAddress: businessInfo.address,
            businessCity: businessInfo.city,
            businessState: businessInfo.stateProvince,
            businessCountry: businessInfo.country,
        });
        // if (!validateForm()) return; // Ensure validation returns a boolean
        if (!validateBusinessForm() && !isBusinessFilled) return; // Ensure validation returns a boolean

        console.log("Submitting business info:", businessInfo);
        if (!businessInfo.plan && isExpired) {
            toast.error("Please select a plan to proceed", { autoClose: 2500 });
            return;
        }
        const payload = {
            priceId: businessInfo.plan,
            sessionId: sessionId,
            // firstName: formData.firstName,
            // lastName: formData.lastName,
            // phoneNumber:
            //   "+" + Number(`${formData.countryCode}${formData.phoneNumber}`),
            // emailId: formData.email,
            businessName: businessInfo.businessName,
            businessEmailId: businessInfo.emailId,
            businessPhone:
                "+" + Number(businessInfo.countryCode) + businessInfo.businessPhone,
            businessAddress: businessInfo.address,
            businessCity: businessInfo.city,
            businessState: businessInfo.stateProvince,
            businessCountry: businessInfo.country,
            businessZipcode: businessInfo.zipCode,
            businessLocationCount: Number(businessInfo.noOfLocations),
            businessUserCount: 1,
            webSiteId: localStorage.getItem("website"),
            // trialDays: selected,
            // ...(businessInfo.plan ? { priceId: businessInfo.plan } : {}),
        };


        //Testing Purpose
        // setAnalyticStarted(false)
        // handleBusinessFormSubmit(true)
        const apiUrl = isBusinessFilled
            ? "payment/plan-selection-proceed"
            : "payment/create-new-free-trial-step2";

        try {
            const response = await axiosInstance.post(
                API_BASE_URL + apiUrl,
                payload
            );
            if (response.status >= 200 && response.status <= 300) {
                // setAnalyticStarted(false)
                // handleStripe();
                // if (isLigerDomain) {
                if (response.data.data.url && businessInfo.plan) {
                    Cookies.remove("userToken")
                    window.location.href = response.data.data.url;
                } else {
                    setLigerModalOpen(prev => !prev);
                }

                // } 
                // else {
                //     Cookies.remove("userToken")
                //     if (API_VITE_CHECKOUT === "0") {
                //         // setSuccessOpen(true);
                //     } else {
                //         // setSubmitBtnStatus(true);
                //         setTimeout(() => {
                //             window.location.href = response.data.data.url;
                //         });
                //     }
                // }
            }
        } catch (error) {
            // handleBusinessFormSubmit(false);
            const err = error as AxiosError<{ message: string }>;
            toast.error(err.response?.data?.message || "Something went wrong", {
                autoClose: 1000,
            });
        }
        // }
    };

    const handleopenterms = (type: "terms" | "privacy") => {
        setModalType(type);
        setModalTitle(
            type === "terms" ? t("terms_conditions") : t("privacy_policy")
        );
        setOpenterms(true);
    };

    const handlecloseterms = () => {
        setOpenterms(false);
    };


    const handleLigerModalClose = () => {
        setBusinessInfo(emptyBusinessInfo)
        setLigerModalOpen(false)
        setOpenModal(false)
    }



    const handleSelect = (plan: string) => {
        // setSelectedPlan(plan);
        setBusinessInfo((prev) => ({
            ...prev,
            plan,
        }));
        console.log("Selected plan:", plan);
    };
    return (
        <div>
            <Modal
                open={ligerModalOpen}
                onClose={handleLigerModalClose}
                aria-labelledby="thanks-title"
                aria-describedby="thanks-description"
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: { xs: "90%", sm: 400 },
                        bgcolor: "background.paper",
                        borderRadius: 3,
                        boxShadow: 24,
                        p: 4,
                        textAlign: "center",
                    }}
                >
                    <Typography id="thanks-title" variant="h6" component="h2" gutterBottom>
                        🎉 Congrats!
                    </Typography>
                    <Typography id="thanks-description" sx={{ mb: 3 }}>
                        You're now eligible to copy and share your favorite animations to your patients.
                    </Typography>
                    <Button variant="contained" onClick={handleLigerModalClose} fullWidth>
                        Okay
                    </Button>
                </Box>
            </Modal>
            <Modal open={openModal} onClose={() => {
                setBusinessFormErrors({
                    businessName: "",
                    emailId: "",
                    businessPhone: "",
                    address: "",
                    city: "",
                    stateProvince: "",
                    country: "",
                    countryFlag: "us",
                    countryCode: "+1",
                    zipCode: "",
                    noOfLocations: "1",
                    plan: "",
                })
                onCloseModal()
            }}>
                <Box sx={style} >
                    <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        px: 4,
                        pt: 3,
                    }}>

                        <Typography
                            variant="h6"
                            gutterBottom
                        >
                           {t("business_details")} {/* Subscribe and Get Premium Benefits */}
                        </Typography>
                        <Close onClick={() => {
                            setBusinessFormErrors({
                                businessName: "",
                                emailId: "",
                                businessPhone: "",
                                address: "",
                                city: "",
                                stateProvince: "",
                                country: "",
                                countryFlag: "us",
                                countryCode: "+1",
                                zipCode: "",
                                noOfLocations: "1",
                                plan: "",
                            })
                            onCloseModal()
                        }} sx={{
                            // bgcolor: "gray",
                            borderRadius: "50%",
                            cursor: "pointer",
                            p: 1,
                            border: "1px solid #e5e5e5",
                            "&:hover": {
                                border: "1px solid #afababff",
                                bgcolor: "#ecececff"
                            }
                        }} />
                    </Box>

                    <Grid data-lenis-prevent container maxWidth="lg" sx={{
                        overflow: "auto",
                        maxHeight: "65vh",
                    }}>

                        {!isBusinessFilled && <Grid item lg={6}>

                            <Box
                                sx={{
                                    borderRadius: "12px",
                                    height: "100%",
                                    overflow: "auto",
                                    p: 4
                                    // pointerEvents: submitPersonalInformation ? "auto" : "none",
                                    // opacity: submitPersonalInformation ? 1 : 0
                                }}
                            >
                                <Typography
                                    className="heading"
                                    variant="h5"
                                    color="primary.main"
                                    fontWeight="bold"
                                    gutterBottom
                                >
                                    {t("business_information")}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    sx={{ mb: 3 }}
                                >
                                    {t("free_trial_select_business_details")}
                                </Typography>
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: 2,
                                    }}
                                >
                                    <Box sx={{ display: "flex", gap: 2 }}>
                                        <TextField
                                            label={t("business_name")}
                                            variant="outlined"
                                            fullWidth
                                            name="businessName"
                                            value={businessInfo.businessName}
                                            onChange={handleBusinessInfoChange}
                                            error={Boolean(businessFormErrors.businessName)}
                                            helperText={businessFormErrors.businessName}
                                            required
                                            size="small"
                                            InputProps={{
                                                sx: {
                                                    borderRadius: "8px",
                                                    height: "44px",
                                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: "#1976D2",
                                                    },
                                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                    {
                                                        borderColor: "#1976D2",
                                                        borderWidth: "2px",
                                                    },
                                                },
                                            }}
                                            InputLabelProps={{
                                                sx: {
                                                    fontSize: "14px",
                                                    lineHeight: "25px",
                                                },
                                            }}
                                        />
                                        <TextField
                                            label={t("email_address")}
                                            variant="outlined"
                                            fullWidth
                                            name="emailId"
                                            value={businessInfo.emailId}
                                            onChange={handleBusinessInfoChange}
                                            error={Boolean(businessFormErrors.emailId)}
                                            helperText={businessFormErrors.emailId}
                                            required
                                            size="small"
                                            InputProps={{
                                                sx: {
                                                    borderRadius: "8px",
                                                    height: "44px",
                                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: "#1976D2",
                                                    },
                                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                    {
                                                        borderColor: "#1976D2",
                                                        borderWidth: "2px",
                                                    },
                                                },
                                            }}
                                            InputLabelProps={{
                                                sx: {
                                                    fontSize: "14px",
                                                    lineHeight: "25px",
                                                },
                                            }}
                                        />
                                    </Box>

                                    <Box sx={{ display: "flex", gap: 1 }}>
                                        <Select
                                            name="countryCode"
                                            value={businessInfo.countryCode}
                                            onChange={handleBusinessInfoSelect}
                                            displayEmpty
                                            required
                                            renderValue={(selected) => {
                                                const selectedCountry = countryOptions.find(
                                                    (option) => option.code === selected
                                                );
                                                return selectedCountry ? (
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        <img
                                                            src={`https://flagcdn.com/16x12/${selectedCountry.flag}.png`}
                                                            alt={selectedCountry.flag}
                                                            style={{
                                                                width: 30,
                                                                height: 22,
                                                                marginRight: 5,
                                                            }}
                                                        />
                                                        <span style={{ fontSize: "12px" }}>
                                                            {selectedCountry.code}
                                                        </span>
                                                    </div>
                                                ) : null;
                                            }}
                                            MenuProps={{
                                                anchorOrigin: {
                                                    vertical: "bottom",
                                                    horizontal: "left",
                                                },
                                                transformOrigin: {
                                                    vertical: "top",
                                                    horizontal: "left",
                                                },
                                                PaperProps: {
                                                    style: {
                                                        maxHeight: 200, // Decrease the height of the list view
                                                    },
                                                },
                                            }}
                                            sx={{
                                                width: "120px", // Reduce select field width
                                                height: "45px", // Reduce select field height
                                                fontSize: "12px", // Reduce text size
                                                "& .MuiSelect-select": {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    padding: "4px 8px",
                                                },
                                            }}
                                        >
                                            {countryOptions.map((option) => (
                                                <MenuItem
                                                    sx={{
                                                        fontSize: "12px", // Small text size in dropdown
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "5px",
                                                        padding: "5px 10px", // Small padding for compact look
                                                    }}
                                                    key={option.code}
                                                    value={option.code}
                                                >
                                                    <img
                                                        src={`https://flagcdn.com/16x12/${option.flag}.png`}
                                                        alt={`${option.name} flag`}
                                                        style={{ width: 16, height: 12 }}
                                                    />
                                                    {option.name} ({option.code})
                                                </MenuItem>
                                            ))}
                                        </Select>

                                        <TextField
                                            label={t("phone_number")}
                                            variant="outlined"
                                            fullWidth
                                            id="contactInfo"
                                            name="businessPhone"
                                            value={businessInfo.businessPhone}
                                            onChange={handleBusinessInfoChange}
                                            onKeyPress={allowOnlyNumbers}
                                            onPaste={handlePaste}
                                            error={Boolean(businessFormErrors.businessPhone)}
                                            helperText={businessFormErrors.businessPhone}
                                            required
                                            InputProps={{
                                                sx: {
                                                    borderRadius: "8px",
                                                    height: "44px",
                                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: "#1976D2",
                                                    },
                                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                    {
                                                        borderColor: "#1976D2",
                                                        borderWidth: "2px",
                                                    },
                                                },
                                            }}
                                            InputLabelProps={{
                                                sx: {
                                                    fontSize: "14px",
                                                    lineHeight: "10px",
                                                },
                                            }}
                                        />
                                    </Box>
                                    <Box sx={{ display: "flex", gap: 2 }}>
                                        <TextField
                                            label={t("address")}
                                            variant="outlined"
                                            fullWidth
                                            name="address"
                                            value={businessInfo.address}
                                            onChange={handleBusinessInfoChange}
                                            error={Boolean(businessFormErrors.address)}
                                            helperText={businessFormErrors.address}
                                            required
                                            size="small"
                                            InputProps={{
                                                sx: {
                                                    borderRadius: "8px",
                                                    height: "44px",
                                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: "#1976D2",
                                                    },
                                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                    {
                                                        borderColor: "#1976D2",
                                                        borderWidth: "2px",
                                                    },
                                                },
                                            }}
                                            InputLabelProps={{
                                                sx: {
                                                    fontSize: "14px",
                                                    lineHeight: "25px",
                                                },
                                            }}
                                        />
                                        <TextField
                                            label={t("city")}
                                            variant="outlined"
                                            fullWidth
                                            name="city"
                                            value={businessInfo.city}
                                            onChange={handleBusinessInfoChange}
                                            error={Boolean(businessFormErrors.city)}
                                            helperText={businessFormErrors.city}
                                            required
                                            size="small"
                                            InputProps={{
                                                sx: {
                                                    borderRadius: "8px",
                                                    height: "44px",
                                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: "#1976D2",
                                                    },
                                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                    {
                                                        borderColor: "#1976D2",
                                                        borderWidth: "2px",
                                                    },
                                                },
                                            }}
                                            InputLabelProps={{
                                                sx: {
                                                    fontSize: "14px",
                                                    lineHeight: "25px",
                                                },
                                            }}
                                        />
                                    </Box>

                                    <Box sx={{ display: "flex", gap: 2 }}>
                                        <TextField
                                            label={t("state_province")}
                                            variant="outlined"
                                            fullWidth
                                            name="stateProvince"
                                            value={businessInfo.stateProvince}
                                            onChange={handleBusinessInfoChange}
                                            error={Boolean(businessFormErrors.stateProvince)}
                                            helperText={businessFormErrors.stateProvince}
                                            required
                                            size="small"
                                            InputProps={{
                                                sx: {
                                                    borderRadius: "8px",
                                                    height: "44px",
                                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: "#1976D2",
                                                    },
                                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                    {
                                                        borderColor: "#1976D2",
                                                        borderWidth: "2px",
                                                    },
                                                },
                                            }}
                                            InputLabelProps={{
                                                sx: {
                                                    fontSize: "14px",
                                                    lineHeight: "25px",
                                                },
                                            }}
                                        />
                                        <TextField
                                            label={t("country")}
                                            variant="outlined"
                                            fullWidth
                                            name="country"
                                            value={businessInfo.country}
                                            onChange={handleBusinessInfoChange}
                                            error={Boolean(businessFormErrors.country)}
                                            helperText={businessFormErrors.country}
                                            required
                                            size="small"
                                            InputProps={{
                                                sx: {
                                                    borderRadius: "8px",
                                                    height: "44px",
                                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: "#1976D2",
                                                    },
                                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                    {
                                                        borderColor: "#1976D2",
                                                        borderWidth: "2px",
                                                    },
                                                },
                                            }}
                                            InputLabelProps={{
                                                sx: {
                                                    fontSize: "14px",
                                                    lineHeight: "25px",
                                                },
                                            }}
                                        />
                                    </Box>

                                    <Box sx={{ display: "flex", gap: 2 }}>
                                        <TextField
                                            label={t("zipcode")}
                                            variant="outlined"
                                            fullWidth
                                            name="zipCode"
                                            value={businessInfo.zipCode}
                                            onChange={handleBusinessInfoChange}
                                            error={Boolean(businessFormErrors.zipCode)}
                                            helperText={businessFormErrors.zipCode}
                                            required
                                            size="small"
                                            InputProps={{
                                                sx: {
                                                    borderRadius: "8px",
                                                    height: "44px",
                                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: "#1976D2",
                                                    },
                                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                    {
                                                        borderColor: "#1976D2",
                                                        borderWidth: "2px",
                                                    },
                                                },
                                            }}
                                            InputLabelProps={{
                                                sx: {
                                                    fontSize: "14px",
                                                    lineHeight: "25px",
                                                },
                                            }}
                                        />
                                        <TextField
                                            label={t("no_of_locations")}
                                            variant="outlined"
                                            fullWidth
                                            name="noOfLocations"
                                            value={businessInfo.noOfLocations}
                                            onChange={handleBusinessInfoChange}
                                            required
                                            disabled
                                            size="small"
                                            type="number"
                                            InputProps={{
                                                sx: {
                                                    borderRadius: "8px",
                                                    height: "44px",
                                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                                        borderColor: "#1976D2",
                                                    },
                                                    "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                                    {
                                                        borderColor: "#1976D2",
                                                        borderWidth: "2px",
                                                    },
                                                },
                                            }}
                                            InputLabelProps={{
                                                sx: {
                                                    fontSize: "14px",
                                                    lineHeight: "25px",
                                                },
                                            }}
                                        />
                                    </Box>

                                    {isMobile && (<Grid item lg={12}>
                                        {isExpired ?
                                            <Box sx={{ position: "relative", p: 2, height: "100%" }}>
                                                {/* Background Image */}
                                                <Box
                                                    sx={{
                                                        position: "absolute",
                                                        inset: 0,
                                                        backgroundImage: `url(${planbg})`,
                                                        backgroundSize: "cover",
                                                        borderRadius: "20px",
                                                        backgroundPosition: "center",
                                                        zIndex: 0,
                                                    }}
                                                />
                                                <Box sx={{ position: "relative", zIndex: 1, height: "100%" }}>
                                                    <Grid
                                                        container
                                                        spacing={2}
                                                        justifyContent="center"
                                                        alignItems="center"
                                                        sx={{ gap: "20px", margin: "0 auto", height: "100%", width: "auto", alignContent: "center", padding: "20px 0" }}
                                                    >
                                                        <Grid sm={12} md={12} lg={12} sx={{ textAlign: "center" }}>
                                                            <Typography
                                                                variant="h5"
                                                                sx={{
                                                                    fontWeight: "600",
                                                                    color: "#FFFFFF",
                                                                }}
                                                            >
                                                                Select a Plan
                                                            </Typography>
                                                            <Typography
                                                                variant="subtitle2"
                                                                sx={{
                                                                    fontWeight: "500",
                                                                    color: "#FFFFFF",
                                                                }}
                                                            >
                                                                Empower Your Journey with the Right Plan
                                                            </Typography>
                                                        </Grid>
                                                        <PlanDetails selectedPlan={businessInfo.plan} onSelect={handleSelect} />
                                                        <Grid lg={12} sx={{ textAlign: "center" }}>
                                                            {isBusinessFilled && <Button
                                                                variant="contained"
                                                                sx={{
                                                                    width: { xs: "100%", sm: "160px" },
                                                                    borderRadius: "10px",
                                                                    textTransform: "none",
                                                                    py: 1.5,
                                                                    fontSize: "1rem",
                                                                    "&.Mui-disabled": {
                                                                        backgroundColor: "#B0BEC5", // custom grey for disabled
                                                                        color: "#FFFFFF",           // text color when disabled
                                                                        opacity: 0.7,               // optional, for a softer look
                                                                    },
                                                                }}
                                                                onClick={handleSubmit}
                                                            >
                                                                {t("proceed")}
                                                            </Button>}
                                                        </Grid>
                                                    </Grid>
                                                </Box>
                                            </Box>
                                            : ""}
                                        {/* <Box component={"img"} src={instructions} /> */}
                                    </Grid>)}
                                    <Stack direction="row" alignItems="flex-start">
                                        <Checkbox
                                            required
                                            checked={isChecked}
                                            onChange={handleCheckboxChange}
                                            size="small"
                                            sx={{ padding: "0px", marginRight: "5px" }}
                                        />
                                        <Typography
                                            variant="caption"
                                            sx={{ lineHeight: 1.5, fontSize: "13px" }}
                                        >
                                            By proceeding, I hereby confirm that I have reviewed
                                            and accept the{" "}
                                            <Link
                                                href="#"
                                                target="_blank"
                                                rel="noopener"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleopenterms("terms");
                                                }}
                                            >
                                                Terms & Conditions
                                            </Link>{" "}
                                            and{" "}
                                            <Link
                                                href="/privacy"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleopenterms("privacy");
                                                }}
                                            >
                                                Privacy Policy
                                            </Link>{" "}
                                            and all applicable policies.
                                        </Typography>
                                    </Stack>
                                </Box>
                                <Box>
                                    <Grid
                                        container
                                        direction={{ xs: "column-reverse", md: "row" }}
                                        sx={{ mt: 6 }}
                                    >
                                        <Grid
                                            item
                                            xs={12}
                                            md={12}
                                            sx={{
                                                textAlign: "left",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "flex-end",
                                                // border: "1px solid red",

                                            }}
                                        >
                                            <Button
                                                variant="contained"
                                                sx={{
                                                    width: { xs: "100%", sm: "160px" },
                                                    borderRadius: "10px",
                                                    textTransform: "none",
                                                    py: 1.5,
                                                    fontSize: "1rem",
                                                    // bgcolor: isGynacDomain ? "#f17b9e" : ""
                                                }}
                                                disabled={!isChecked}
                                                onClick={handleSubmit}
                                            >
                                                {t("proceed")}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                                {((isMobile || isExpired) && isBusinessFilled) && (<Box pt={2} component={"img"} src={instructions} />)}
                            </Box>
                        </Grid>}
                        {(!isMobile || isBusinessFilled) && (<Grid item lg={!isBusinessFilled ? 6 : 12} sx={{ p: 2, height: "65vh", overflow: "auto" }}>
                            {isExpired ?
                                <Box sx={{ position: "relative", p: 2,  height: "auto" }}>
                                    {/* Background Image */}
                                    <Box
                                        sx={{
                                            position: "absolute",
                                            inset: 0,
                                            backgroundImage: `url(${planbg})`,
                                            backgroundSize: "cover",
                                            borderRadius: "20px",
                                            backgroundPosition: "center",
                                            zIndex: 0,
                                        }}
                                    />
                                    <Box sx={{ position: "relative", zIndex: 1, height: "100%" }}>
                                        <Grid
                                            container
                                            spacing={2}
                                            justifyContent="center"
                                            alignItems="center"
                                            sx={{ gap: "20px", margin: "0 auto", height: "100%", width: "auto", alignContent: "center", padding: "20px 0" }}
                                        >
                                            <Grid sm={12} md={12} lg={12} sx={{ textAlign: "center" }}>
                                                <Typography
                                                    variant="h5"
                                                    sx={{
                                                        fontWeight: "600",
                                                        color: "#FFFFFF",
                                                    }}
                                                >
                                                    Select a Plan
                                                </Typography>
                                                <Typography
                                                    variant="subtitle2"
                                                    sx={{
                                                        fontWeight: "500",
                                                        color: "#FFFFFF",
                                                    }}
                                                >
                                                    Empower Your Journey with the Right Plan
                                                </Typography>
                                            </Grid>
                                            <PlanDetails selectedPlan={businessInfo.plan} onSelect={handleSelect} />
                                            <Grid lg={12} sx={{ textAlign: "center" }}>
                                                {isBusinessFilled && <Button
                                                    variant="contained"
                                                    sx={{
                                                        width: { xs: "100%", sm: "160px" },
                                                        borderRadius: "10px",
                                                        textTransform: "none",
                                                        py: 1.5,
                                                        fontSize: "1rem",
                                                        "&.Mui-disabled": {
                                                            backgroundColor: "#B0BEC5", // custom grey for disabled
                                                            color: "#FFFFFF",           // text color when disabled
                                                            opacity: 0.7,               // optional, for a softer look
                                                        },
                                                    }}
                                                    onClick={handleSubmit}
                                                >
                                                    {t("proceed")}
                                                </Button>}
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Box>
                                : <Box component={"img"} sx={{ width: "100%", height: "60vh", overflow: "hidden", objectFit: "contain" }} src={instructions} />}
                            {/* <Box component={"img"} src={instructions} /> */}
                        </Grid>)}

                    </Grid>

                </Box>
            </Modal>
            <TermsandConditions open={openterms} title={modalTitle} handleCloseTerms={handlecloseterms} type={modalType} />
        </div>
    )
}
